<template>
  <main
    class="article container"
    :class="{ 'article-success': showExtraContent }"
  >
    <ReservationSuccessContent :reservation-id="props.reservationId" />

    <SuccessExtraContent v-if="showExtraContent" origin="reservationSuccess" />
  </main>
</template>

<script lang="ts" setup>
import ReservationSuccessContent from "./reservation-success-content.vue";
import SuccessExtraContent from '../shared/SuccessExtraContent.vue';

const props = defineProps<{
  reservationId: string;
}>();

const showExtraContent = !!window.showExtraContentInSuccessPages;
</script>
